import React, { useState, useEffect } from "react";
import Switch from 'react-switch';

import close from "../imgs/icons/close.svg";
import delet from '../imgs/icons/delete.svg';
import modifica from '../imgs/icons/modifica.svg';
import confirmW from '../imgs/icons/confirmW.svg';
import save from '../imgs/icons/save.svg';
import addW from '../imgs/icons/addW.svg';
import carica from '../imgs/icons/carica.svg';

const AllarmiAssenza = ({
  langSet,
  accountData,
  allarmiassenzastanza,
  setAllarmiassenzastanza,
  selettoreAllarmiassenzastanza,
  allarmiassenzastanzaSwitch,
  salvaModifiche,
  modificaType,
  getallarmiassenzastanza,
  openProfiloPopup,
  defContinua,
  mod,
  setMod,
  sensoriStanza
}) => {
  // Handle input changes for descrizione, inizio, and fine
  const handleChange = (e, index, field) => {
    const updatedAllarmi = [...allarmiassenzastanza];
    updatedAllarmi[index][field] = e.target.value;
    setAllarmiassenzastanza(updatedAllarmi);
  };

  // Handle adding or updating allarme status
  const handleStatusChange = (checked, index) => {
    const newValue = checked ? "Allarme immediato" : "Allarme disabilitato";

      const allarme = allarmiassenzastanza[index];  // Get the current alarm object
      if (allarme.id) {
          allarmiassenzastanzaSwitch({mode: 'edit', id_edit: allarme.id, stato: newValue} );
      }

    const updatedAllarmi = [...allarmiassenzastanza];
    updatedAllarmi[index].stato = newValue;
    setAllarmiassenzastanza(updatedAllarmi);
  };

  // Handle switch action for adding new allarme
  const handleAddAllarme = (sensore, direzione, allarme) => {
    allarmiassenzastanzaSwitch({mode: 'add', id: sensore, direction: direzione, alarm: allarme});
  };

  const [showPopupDoor, setShowPopupDoor] = useState(false);
  const [selectedDoorSensor, setSelectedDoorSensor] = useState("");
  const [selectedDoorEvent, setSelectedDoorEvent] = useState("");
  const doorEvents = ['Enter', 'Exit'];
  const [selectedAllarmeStringa, setSelectedAllarmeStringa] = useState("");
  const allarmiStrings = ['uscita dalla stanza', 'entrata nella stanza'];

  const getDirection = (tipo) => {
    const typesForExit = ['allarme', 'leaving_sensor_room', 'entering_room'];
    const typesForEnter = ['entering_sensor_room', 'leaving_room'];
    console.log("tipo: ", tipo)
    if (typesForExit.includes(tipo)) return 'Exit';
    if (typesForEnter.includes(tipo)) return 'Enter';
    return 'Error';
  }

  return (
    <div>
      <table id="TitoliLista">
        <colgroup>
          <col style={{ width: '15%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '7%' }} />
          <col style={{ width: '28%' }} />
          <col style={{ width: '10%' }} />
          <col style={{ width: '15%' }} />
          <col style={{ width: '15%' }} />
        </colgroup>
        <tbody>
          <tr>
            <td style={{ border: 0 }}>{langSet.descrizione}</td>
            <td style={{ border: 0 }}>Da - A</td>
            <td tyle={{ border: 0 }}>Allerta ON</td>
            <td style={{ border: 0 }}>ID Sensore</td>
            <td tyle={{ border: 0 }}>Direzione</td>
            <td style={{ border: 0 }}>Allerta</td>
            <td style={{ border: 0 }}></td>
          </tr>
        </tbody>
      </table>

      <div style={{ overflow: "scroll", minHeight: "20em", maxHeight: "25em" }}>
        {allarmiassenzastanza.length > 0 ? (
          <table id="Lista" style={{ width: '100%' }}>
            <colgroup>
              <col style={{ width: '15%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '7%' }} />
              <col style={{ width: '28%' }} />
              <col style={{ width: '10%' }} />
              <col style={{ width: '15%' }} />
              <col style={{ width: '15%' }} />
            </colgroup>
            <tbody>
              {allarmiassenzastanza.map((allarme, i) => (
                <tr key={allarme.id || i}>
                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {mod === 0 || allarme.id ? (
                      allarme.descrizione
                    ) : (
                      <input
                        type="text"
                        placeholder={langSet.inserisciDescrizione}
                        onChange={(e) => handleChange(e, i, 'descrizione')}
                        style={{ width: "85%" }}
                      />
                    )}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {mod === 0 || allarme.id ? (
                      `${allarme.inizio} - ${allarme.fine}`
                    ) : (
                      <>
                        <input
                          type="time"
                          style={{ width: "5.25em" }}
                          onChange={(e) => handleChange(e, i, 'inizio')}
                        />
                        &ensp;
                        <input
                          type="time"
                          style={{ width: "5.25em" }}
                          onChange={(e) => handleChange(e, i, 'fine')}
                        />
                      </>
                    )}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {mod === 0 ? (
                      <Switch
                        checked={allarme.stato === "Allarme immediato"}
                        onColor="#86d3ff"
                        offColor="#cccccc"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={24}
                        width={48}
                        disabled
                      />
                    ) : (
                      <>
                        <select
                          value={allarme.stato}
                          style={{ width: "150%", padding: 0, display: 'none' }}
                          onChange={(e) => {
                            if (allarme.id) {
                              allarmiassenzastanzaSwitch({
                                mode: 'edit',
                                id_edit: allarme.id,
                                stato: e.target.value
                              });
                            }
                            allarmiassenzastanza[i].stato = e.target.value;
                            setAllarmiassenzastanza([...allarmiassenzastanza]);
                          }}
                          required
                        >
                          <option value="0" disabled>- - -</option>
                          {selettoreAllarmiassenzastanza.map((currSel, index) => (
                            <option key={index} value={currSel}>{currSel}</option>
                          ))}
                        </select>

                        <Switch
                          onChange={(checked) => handleStatusChange(checked, i)}
                          checked={allarme.stato === "Allarme immediato"}
                          onColor="#86d3ff"
                          offColor="#cccccc"
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={24}
                          width={48}
                        />
                      </>
                    )}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {allarme.id_sensore}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {allarme.doorEvent === undefined ? (
                      getDirection(allarme.tipo)
                    ) : (
                      allarme.doorEvent
                    )}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {allarme.messaggio}
                  </td>

                  <td style={{ padding: 0, paddingLeft: ".5em" }}>
                    {mod === 0 ? null : (
                      <div
                        className="selettore selettoreFlex selettoreBorder"
                        onClick={() =>
                          allarmiassenzastanzaSwitch({
                            mode: 'del',
                            id_remove: allarme.id
                          })
                        }
                      >
                        <p>Elimina</p>
                        <img src={delet} alt="delete" />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={{ textAlign: "center", margin: "1em" }}>
            {langSet.nessunAllarme}
          </p>
        )}
      </div>

      <div className="navigators">
        {mod === 0 ? (
          <div
            className="selettore selettoreFlex selettoreViolet"
            onClick={() => setMod(1)}
            style={{ display: accountData.tipo === 4 ? "none" : null }}
          >
            <p>{langSet.modifica}</p>
            <img src={modifica} alt='modifica' className="icon-popup" />
          </div>
        ) : (
          <>
            <div className="selettore selettoreFlex selettorePurple normPosition" onClick={() => setShowPopupDoor(true)}>
              <p>{langSet.aggiungi}</p>
              <img src={addW} alt="add" className="icon-popup" />
            </div>
            {showPopupDoor && (
              <div className="prePopup">
                <h4>Seleziona sensore porta, direzione e tipo allarme</h4>
                <div style={{ display: 'flex', gap: '1em', width: '100%' }}>
                  <select
                    value={selectedDoorSensor}
                    onChange={(e) => setSelectedDoorSensor(e.target.value)}
                    style={{
                      fontSize: '1em',
                      padding: '0.4em 0.8em',
                      lineHeight: '1.2',
                      height: '2.2em',
                      boxSizing: 'border-box',
                      overflow: 'visible',
                      flex: 1
                    }}
                  >
                    <option value="" disabled>-- Sensore --</option>
                    {sensoriStanza.map((opt, i) => (
                      <option key={i} value={opt.id_sensore}>{opt.nome}</option>
                    ))}
                  </select>

                  <select
                    value={selectedDoorEvent}
                    onChange={(e) => setSelectedDoorEvent(e.target.value)}
                    style={{
                      fontSize: '1em',
                      padding: '0.4em 0.8em',
                      lineHeight: '1.2',
                      height: '2.2em',
                      boxSizing: 'border-box',
                      overflow: 'visible',
                      flex: 1
                    }}
                  >
                    <option>-- type13 Enter/Exit --</option>
                    {doorEvents.map((opt, i) => (
                      <option key={i} value={opt}>{opt}</option>
                    ))}
                  </select>

                  <select
                    value={selectedAllarmeStringa}
                    onChange={(e) => setSelectedAllarmeStringa(e.target.value)}
                    style={{
                      fontSize: '1em',
                      padding: '0.4em 0.8em',
                      lineHeight: '1.2',
                      height: '2.2em',
                      boxSizing: 'border-box',
                      overflow: 'visible',
                      flex: 1
                    }}
                  >
                    <option>-- Entrata/Uscita --</option>
                    {allarmiStrings.map((opt, i) => (
                      <option key={i} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>

                <div style={{ marginTop: "1em" }}>
                  <button
                    onClick={() => {
                      handleAddAllarme(selectedDoorSensor, selectedDoorEvent, selectedAllarmeStringa);
                      setShowPopupDoor(false);
                    }}
                  >
                    OK
                  </button>
                  <button onClick={() => setShowPopupDoor(false)} style={{ marginLeft: "0.5em" }}>
                    Annulla
                  </button>
                </div>
              </div>
            )}

            <div className={defContinua} onClick={() => salvaModifiche(modificaType)}>
              <p>{langSet.salva}</p>
              <img src={confirmW} alt='arrow' className="icon-popup" />
            </div>
            <div className="selettore selettoreFlex selettoreViolet" onClick={async () => { await getallarmiassenzastanza(); setMod(0); }}>
              <p>{langSet.annulla}</p>
              <img src={close} alt="close" className="icon-popup" />
            </div>
            <div className="selettore selettoreFlex selettoreBorder" onClick={() => openProfiloPopup("salva")}>
              <p>Salva Profilo</p>
              <img src={save} alt="save" className="icon-popup" />
            </div>
            <div className="selettore selettoreFlex selettoreBorder" onClick={() => openProfiloPopup("carica")}>
              <p>Carica Profilo</p>
              <img src={carica} alt="carica" className="icon-popup" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AllarmiAssenza;
